var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrajakt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    role: "img",
    "aria-label": "Parijat flower",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    stroke: "#f0e6d2",
    strokeWidth: 0.6
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 14,
    rx: 7.5,
    ry: 12,
    transform: "rotate(0 32 32)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 14,
    rx: 7.5,
    ry: 12,
    transform: "rotate(72 32 32)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 14,
    rx: 7.5,
    ry: 12,
    transform: "rotate(144 32 32)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 14,
    rx: 7.5,
    ry: 12,
    transform: "rotate(216 32 32)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 14,
    rx: 7.5,
    ry: 12,
    transform: "rotate(288 32 32)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 8.5,
    fill: "#f97316"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 4.5,
    fill: "#fb923c"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 1.8,
    fill: "#fff7ed"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrajakt);
export default __webpack_public_path__ + "static/media/prajakt.4f5efd413619edb5efa9a37867795e47.svg";
export { ForwardRef as ReactComponent };